import React, { ButtonHTMLAttributes } from 'react';

interface ButtonPrimaryProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	label: string;
	isDisable?: boolean;
}

const ButtonBlockPrimary = (props: ButtonPrimaryProps) => {
	const { label, isDisable, ...nativeProps } = props;
	return (
		<>
			<button
				{...nativeProps}
				className="btn btn-block btn-primary"
				disabled={isDisable}
			>
				{label}
			</button>
		</>
	);
};

export default ButtonBlockPrimary;
